const locale = {
	// #region Contracts fields
	DETAILS_CONTRACTS_FIELD_TITLE: 'Title',
	DETAILS_CONTRACTS_FIELD_STATUS: 'Contract Status',
	DETAILS_CONTRACTS_FIELD_TYPE: 'Contract Type',
	DETAILS_CONTRACTS_FIELD_COMPANY: 'Customer Company',
	DETAILS_CONTRACTS_FIELD_PERSON: 'External Reference',
	DETAILS_CONTRACTS_FIELD_ASSIGNED_USER: 'Internal assigned User',
	DETAILS_CONTRACTS_FIELD_ASSIGNED_USER_2: 'External assigned User',
	DETAILS_CONTRACTS_FIELD_DATE_FROM: 'Start date',
	DETAILS_CONTRACTS_FIELD_DATE_TO: 'End date',
	DETAILS_CONTRACTS_FIELD_SIGNDATE: 'Sign date',
	DETAILS_CONTRACTS_FIELD_RATING: 'Rating',
	DETAILS_CONTRACTS_FIELD_VALUE_FIXED: 'Value fixed',
	DETAILS_CONTRACTS_FIELD_VALUE_PERCENTAGE: 'Value percentage',
	DETAILS_CONTRACTS_FIELD_EXPENSES: 'Expenses',
	DETAILS_CONTRACTS_FIELD_TAGS: 'Tags',
	DETAILS_CONTRACTS_FIELD_WARNING: 'Warning',
	DETAILS_CONTRACTS_FIELD_BLOCKED: 'Blocked',
	// #endregion

	// #region Contracts Lines
	CONTRACTS_LINES_FOOTER_TOT_AMOUNT: 'Tot amount: {value}',

	DETAILS_CONTRACTS_LINES_FIELD_BILLING_DATE: 'Billing date',
	DETAILS_CONTRACTS_LINES_FIELD_AMOUNT: 'Amount',
	DETAILS_CONTRACTS_LINES_FIELD_DESCRIPTION: 'Description',
	DETAILS_CONTRACTS_LINES_FIELD_BILLED: 'Billed',
	DETAILS_CONTRACTS_LINES_FIELD_INVOICE: 'Invoice number',
	DETAILS_CONTRACTS_LINES_FIELD_DATE_BILLED: 'Invoice date',

	DETAILS_CONTRACTS_LINES_BUTTON_EDIT_LINES: 'Edit rows',
	DETAILS_CONTRACTS_LINES_BUTTON_ADD_ITEM: 'Add row',
	DETAILS_CONTRACTS_LINES_BUTTON_DELETE_LINES: 'Delete rows',

	DIALOG_CONTRACTS_LINES_DIALOG_ADD_TITLE: 'Add row',
	DIALOG_CONTRACTS_LINES_DIALOG_EDIT_TITLE: 'Edit row'
	// #endregion
};

export default locale;
